import { render, staticRenderFns } from "./DrawerDivider.vue?vue&type=template&id=7a060c8e&scoped=true&"
import script from "./DrawerDivider.vue?vue&type=script&lang=js&"
export * from "./DrawerDivider.vue?vue&type=script&lang=js&"
import style0 from "./DrawerDivider.vue?vue&type=style&index=0&id=7a060c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a060c8e",
  null
  
)

export default component.exports